import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { summaryConstants, summaryModels } from '..';

export const useSummaryInsightWithDateResult = (props: { dateType: string; date: string }) =>
  useQuery<summaryModels.Insight>({
    queryKey: [summaryConstants.queryKeys.SUMMARY_INSIGHT_WITH_DATE_RESULT, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/summary-insight/with-date/result',
          query: props
        })
      );

      return res?.data?.data;
    },
    enabled: !!props
  });
